/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_SubjectInputs */

const es_chat_tool_detail_subject = /** @type {(inputs: Chat_Tool_Detail_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asunto`)
};

const en_chat_tool_detail_subject = /** @type {(inputs: Chat_Tool_Detail_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Chat_Tool_Detail_SubjectInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_subject = /** @type {((inputs?: Chat_Tool_Detail_SubjectInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_SubjectInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_subject(inputs)
	return en_chat_tool_detail_subject(inputs)
});
export { chat_tool_detail_subject as "chat.tool_detail.subject" }